export type PhaseTwoParameters = {
    annualPrice: number;
    semesterPrice: number;
    zohoId: string;
};

export class PhaseTwo {
    chECFase_c: string;
    cVidaLeyAnual_c: number;
    cVidaLeySemestral_c: number;
    chECAutoTipifEstado_c: string;

    constructor({ annualPrice, semesterPrice }: PhaseTwoParameters) {
        this.chECFase_c = "cotizacion_planilla";
        this.cVidaLeyAnual_c = Number.parseFloat(annualPrice.toFixed(2));
        this.cVidaLeySemestral_c = Number.parseFloat(semesterPrice.toFixed(2));
        this.chECAutoTipifEstado_c = "solicitar";
    }
}
